var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandOrkin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 53,
    viewBox: "0 0 103 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3115 51.3388L1.41895 26.1768L51.3115 1.01758L101.206 26.1768L51.3115 51.3388Z",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8496 34.2925C28.9246 34.2262 31.5515 30.7091 31.5302 26.1672C31.5071 21.1582 29.1321 17.9724 24.8496 17.9446C20.6035 17.9155 18.1627 21.3599 18.1699 26.1672C18.1759 30.7091 20.9509 34.3546 24.8496 34.2925Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0395 33.8567L38.1282 27.7026V33.8209H33.6484V18.3807H40.1389C41.2551 18.3807 42.2407 18.5942 43.1878 19.3568C44.2481 20.1666 44.992 21.5025 44.992 23.0074C44.992 25.0287 43.8334 26.0402 42.3278 26.8719L45.5658 33.8567H41.0395Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8496 30.3236C25.8877 30.3245 26.4636 28.9519 26.482 26.1005C26.5063 23.3842 26.163 21.9735 24.8141 21.982C23.5685 21.9883 23.1812 23.7189 23.1812 26.0684C23.1809 28.4162 23.6748 30.3193 24.8496 30.3236Z",
    fill: "#696969"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.127 25.1877V21.5119C38.127 21.5119 38.6966 21.4171 39.1684 21.7997C39.65 22.1519 39.9788 22.7346 39.9737 23.3209C39.9707 23.9115 39.5954 24.5414 39.1633 24.9503C38.8281 25.2683 38.127 25.1877 38.127 25.1877Z",
    fill: "#696969"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3013 18.4437H59.7192L56.3151 25.5457L59.8153 33.8567H55.707L52.1359 27.0454H52.1591V33.8567H47.731V18.4437H52.1591V24.6583H52.2047L55.3013 18.4437Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4242 18.4146H62.1357V33.8567H66.4242V18.4146Z",
    fill: "#FAFAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6582 18.4307H74.0064L76.8316 24.7758L76.8268 18.4307H81.2963V33.8558L76.7406 33.8391L74.0389 27.4834L74.0581 33.8558H69.6582V18.4307Z",
    fill: "#FAFAFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6294 43.1825C48.6294 41.6761 49.8207 40.478 51.3191 40.478C52.8209 40.478 54.0046 41.6761 54.0046 43.1825C54.0046 44.692 52.8209 45.8871 51.3191 45.8871C49.8207 45.8871 48.6294 44.692 48.6294 43.1825Z",
    fill: "#FAFAFA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0669 43.1826C49.0669 44.4552 50.0921 45.4482 51.3194 45.4482C52.5479 45.4482 53.5719 44.4552 53.5719 43.1826C53.5719 41.9018 52.5479 40.919 51.3194 40.919C50.0921 40.919 49.0669 41.9018 49.0669 43.1826Z",
    fill: "#696969"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9639 44.4458L51.5056 43.6356H50.7143V44.4624L50.2065 44.4543L50.2144 41.8027H51.5146C52.059 41.8027 52.4981 42.0477 52.5197 42.5896C52.5437 43.1723 52.3152 43.36 51.9116 43.4233L52.5197 44.4415L51.9639 44.4458Z",
    fill: "#FAFAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7144 42.3416V43.0969H51.1483C51.5561 43.0969 52.0356 43.1671 52.0356 42.754C52.0356 42.3685 51.7948 42.3419 51.4357 42.3419L50.7144 42.3416Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandOrkin);
export default __webpack_public_path__ + "static/media/brand-orkin.17da738be6b8c83d12c76ce32cf64fa1.svg";
export { ForwardRef as ReactComponent };